import React, {Component} from 'react';
import '../../styles/Home.css'
import {Button} from "react-bootstrap";
import LoginService from "../../admin/loginComponents/LoginService";
import {Link, withRouter} from "react-router-dom";
import Zgody from "../../shared/Zgody";
import Konto from "../Konto";
import PotwierdzEmail from "./PotwierdzEmail";
import {NotificationManager} from "react-notifications";

class RegisterComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            checked: false,
            lostPassEmail: '',
            registerEmail: '',
            registerPass: '',
            registerPass2: '',
            onRegister: false,
            registerLoading: false,
        };

        this.handleRegisterEmail = this.handleRegisterEmail.bind(this);
        this.handleRegisterPass = this.handleRegisterPass.bind(this);
        this.handleRegisterPass2 = this.handleRegisterPass2.bind(this);
    }

    componentDidMount() {
        this.nameInput.focus();
    }

    handleRegisterEmail(e) {
        this.setState({registerEmail: e.target.value})
    }

    handleRegisterPass(e) {
        this.setState({registerPass: e.target.value})
    }

    handleRegisterPass2(e) {
        this.setState({registerPass2: e.target.value})
    }

    onRegister() {
        this.setState({registerLoading: true})
        let re = /^[a-z\d]+[\w\d.-]*@(?:[a-z\d]+[a-z\d-]+\.){1,5}[a-z]{2,6}$/i;
        if (re.test(this.state.registerEmail) === false) {
            NotificationManager.error("", "Nieprawidłowy adres e-mail ", 5000)
            this.setState({registerLoading: false})

        } else {
            if (this.state.registerPass.length < 8) {
                NotificationManager.error("", "Hasło musi składać się z przynajmniej 8 znaków ", 5000)
                this.setState({registerLoading: false})
            } else {
                if (this.state.registerPass !== this.state.registerPass2) {
                    NotificationManager.error("", "Podane hasła nie są takie same ", 5000)
                    this.setState({registerLoading: false})
                } else {
                    if (this.state.checked === false) {
                        NotificationManager.error("", "Musisz wyrazić zgodę na przetwarzanie danych osobowych ", 5000)
                        this.setState({registerLoading: false})
                    } else {
                        LoginService.postRegister(this.state.registerEmail, this.state.registerPass)
                            .then(function (response) {
                                if (response.status === 201) {
                                    this.setState({onRegister: true, registerLoading: false})
                                }
                            }.bind(this)).catch(e => {
                            this.setState({registerLoading: false})
                        })
                    }
                }
            }
        }
    }

    render() {
        return <Konto>
            {this.state.onRegister ?
                <PotwierdzEmail/>
                :
                <div className="row wynik ramka marginLeftRightMobilka" style={{padding: 50}}>

                    <div className="col-12 text-center">
                        <h2><b>Rejestracja</b></h2>
                        <p style={{fontSize: '0.875rem', paddingTop: '10px', marginBottom: '10px'}}>Aby móc
                            w pełni korzystać z możliwości witryny należy się zarejestrować.</p>
                        <div className="inputLogin"><i className="fa fa-envelope"> </i>
                            <input className="form-control inputLoginControl"
                                   ref={(input) => {
                                       this.nameInput = input;
                                   }}
                                   value={this.state.registerEmail}
                                   onChange={this.handleRegisterEmail}
                                   placeholder="Adres e-mail..."
                                   type="text"/></div>
                        <div className="inputLogin"><i className="fa fa-unlock-alt"> </i>
                            <input className="form-control inputLoginControl"
                                   value={this.state.registerPass}
                                   onChange={this.handleRegisterPass}
                                   placeholder="Hasło..." type="password"/></div>
                        <div className="inputLogin"><i className="fa fa-unlock"> </i>
                            <input className="form-control inputLoginControl"
                                   value={this.state.registerPass2}
                                   onChange={this.handleRegisterPass2}
                                   placeholder="Powtórz hasło..." type="password"/></div>
                        <div className="small" style={{marginTop: 20}}>
                            <Zgody war2={true} warunek={this.state.checked}
                                   setWarunki={() => this.setState({checked: !this.state.checked})}/>
                        </div>
                        <div className="buttonLogin" style={{marginTop: 10}}><Button bsStyle="success"
                                                                                     disabled={this.state.registerLoading}
                                                                                     onClick={() => this.onRegister()}>Zarejestruj</Button>
                            {this.state.registerLoading ? <div className="loaderDim" style={{marginTop: 5}}><i
                                className="fa fa-spinner fa-pulse fa-fw"
                                style={{
                                    color: '#58b13d'
                                }}> </i></div> : null}
                        </div>
                        <div style={{paddingTop: 15, cursor: 'pointer'}}>Powrót do <Link
                            to={'/login'}><b>logowania</b></Link></div>
                    </div>
                </div>}
        </Konto>
    }

}

export default withRouter(RegisterComponent)



// WEBPACK FOOTER //
// ./src/components/konto/kontoComponents/RegisterComponent.js